export const cols = [{
	prop: 'createdate',
	label: '下单时间',
	width: '180',
	ischoose: true,
	disabled: false,
	sortable: false,
	align: 'center'
}, {
	prop: 'ordernode',
	label: '订单状态',
	width: '',
	ischoose: true,
	disabled: false,
	sortable: false,
	align: 'center'
}, {
	prop: 'paymentmode',
	label: '支付方式',
	width: '',
	ischoose: true,
	disabled: false,
	sortable: false,
	align: 'center'
}, {
	prop: 'customername',
	label: '客户名称',
	width: '',
	ischoose: true,
	disabled: false,
	sortable: false,
	align: 'center'
}, {
	prop: 'outpaynumber',
	label: '第三方流水号',
	width: '200',
	ischoose: true,
	disabled: false,
	sortable: false,
	align: 'center'
}, {
	prop: 'paynumber',
	label: '极速订流水号',
	width: '200',
	ischoose: true,
	disabled: false,
	sortable: false,
	align: 'center'
}, {
	prop: 'ordernumber',
	label: '订单编号',
	width: '200',
	ischoose: true,
	disabled: false,
	sortable: false,
	align: 'center'
}, {
	prop: 'amount',
	label: '支付金额',
	width: '',
	ischoose: true,
	disabled: false,
	sortable: false,
	align: 'center'
}, {
	prop: 'finalprice',
	label: '金额（订货）',
	width: '150',
	ischoose: true,
	disabled: false,
	sortable: false,
	align: 'center'
}, {
	prop: 'sendmoney',
	label: '金额（发货）',
	width: '150',
	ischoose: true,
	disabled: false,
	sortable: false,
	align: 'center'
}, {
	prop: 'unpaymoney',
	label: '未支付金额',
	width: '',
	ischoose: true,
	disabled: false,
	sortable: false,
	align: 'center'
}, {
	prop: 'diffmoney',
	label: '差异金额',
	width: '',
	ischoose: true,
	disabled: false,
	sortable: false,
	align: 'center'
}]
